import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type SubmitRatingPayload = {
  workRequestId?: number;
  workInviteId?: number;
  clubProfileId: number;
  artistProfileId: number;
  StaffAndManagement?: number;
  DressingRoom?: number;
  Housing?: number;
  Comment?: string; // текст отзыва
  IsAnonymous?: boolean; // оставить анонимным
};

export type SubmitRatingRequest = {
  artistProfileId: string; // path param - string to match other requests
  payload: SubmitRatingPayload;
};

export type SubmitRatingParams = RequestConfig<SubmitRatingRequest>;

/**
 * POST /api/ratings/{ArtistProfileId}
 * Body: SubmitRatingPayload
 */
export const submitRating = async ({ params, config }: SubmitRatingParams) =>
  api.post<void>(
    `/api/ratings/${params.artistProfileId}`,
    params.payload,
    config
  );
